import React from 'react'

const BuyerSales = () => {
  return (
    <div>
        Buyer Sales
    </div>
  )
}

export default BuyerSales
